module.exports = __webpack_public_path__ + "img/img79.c1528a2c.png";